import type { ReactElement } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/atoms/button';
import { Micro } from '@/components/atoms/micro';

const DESKTOP_MIN_PX = 1024;

export function AdminDesktopOnlyNotice(): ReactElement {
  return (
    <div className="min-h-screen flex-1 flex flex-col items-center justify-center text-center px-8 py-12">
      <Micro>Admin</Micro>
      <h2 className="font-display text-[24px] font-semibold tracking-tight mt-2 leading-tight text-[var(--ink)] max-w-[360px]">
        The admin panel is desktop-only
      </h2>
      <p className="text-[13px] text-[var(--ink-3)] mt-3 leading-relaxed max-w-[360px]">
        Open this page on a desktop (≥ {DESKTOP_MIN_PX}px wide) to access the moderation queue
        and instance tools.
      </p>
      <div className="mt-7 flex flex-col gap-2 w-full max-w-xs">
        <Link to="/repertoire">
          <Button size="lg" fullWidth>
            Back to repertoire
          </Button>
        </Link>
      </div>
    </div>
  );
}
